import Vue from 'vue'

import router from '@/index-router'

import Index from '@/Index.vue'

import axios from 'axios'

import server from '@/utitl/server'

import '@/assets/css/main.css'

import '@/assets/css/swiper.min.css'
import '@/assets/css/reset.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/dist/css/swiper.css'

// import $ from 'jquery'
import VueFullpage from 'vue-fullpage.js'
import 'animate.css'
import '@/assets/css/reset.css'

Vue.use(VueFullpage)
Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

// 挂载到vue实例
Vue.prototype.$host = server;

Vue.use(VueAwesomeSwiper);


new Vue({
    router,
    axios,
    render: h => h(Index)
}).$mount('#main');